// Mirror the backend's get_category_from_path: among all (category, pattern)
// pairs whose pattern matches the path, pick the category owning the longest
// (most specific) pattern. Prevents a broad prefix (e.g. ^/product) from
// swallowing a more specific sibling (^/product_line).
export function resolvePermissionCategory(
  normalizedPath,
  permissionCategories
) {
  let best = null;
  for (const [category, patterns] of Object.entries(permissionCategories)) {
    for (const pattern of patterns) {
      if (normalizedPath.match(RegExp(pattern))) {
        if (!best || pattern.length > best.pattern.length) {
          best = { category, pattern };
        }
      }
    }
  }
  return best?.category;
}
